if (!customElements.get('storefront-navigation')) {
  customElements.define('storefront-navigation', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const on = (target, type, callback) => target?.addEventListener(type, callback, { signal: this.events.signal });
      this.drawer = this.querySelector('.navigation-drawer');
      this.trigger = this.querySelector('[data-nav-open]');
      this.series = this.querySelector('.series-disclosure');
      const summary = this.series?.querySelector('summary');
      const mobile = matchMedia('(max-width: 1100px), (hover: none), (pointer: coarse)');
      const closeSeries = () => { clearTimeout(this.hoverTimer); if (this.series) this.series.open = false; };
      const showPreview = index => this.querySelectorAll('[data-series-image]').forEach(image => { image.hidden = image.dataset.seriesImage !== index; });
      if (typeof this.drawer?.showModal === 'function') {
        this.trigger.hidden = false;
        on(this.trigger, 'click', () => {
          closeSeries();
          this.drawer.showModal();
          this.drawer.scrollTop = 0;
          this.trigger.setAttribute('aria-expanded', 'true');
          this.drawer.focus({ preventScroll: true });
        });
        on(this.drawer.querySelector('[data-nav-close]'), 'click', () => this.drawer.close());
        on(this.drawer, 'close', () => {
          this.trigger.setAttribute('aria-expanded', 'false');
          if (mobile.matches) this.trigger.focus({ preventScroll: true });
        });
        on(this.drawer, 'click', event => {
          if (event.target.closest('a[href]')) { this.drawer.close(); return; }
          if (event.target !== this.drawer) return;
          const box = this.drawer.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.drawer.close();
        });
        on(this.drawer, 'keydown', event => {
          if (event.key !== 'Tab') return;
          const items = [...this.drawer.querySelectorAll('a[href], button:not(:disabled)')].filter(e => e.getClientRects().length);
          const first = items[0], last = items.at(-1);
          if (event.shiftKey && (document.activeElement === first || document.activeElement === this.drawer)) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        });
      }
      on(this.series, 'pointerenter', () => {
        clearTimeout(this.hoverTimer);
        if (!mobile.matches) this.hoverTimer = setTimeout(() => { this.series.open = true; }, 140);
      });
      on(this.series, 'pointerleave', () => {
        clearTimeout(this.hoverTimer);
        if (!this.series.contains(document.activeElement)) this.hoverTimer = setTimeout(closeSeries, 180);
      });
      // Capture state at pointer-down, before a pending hover timer can toggle it.
      on(summary, 'pointerdown', () => {
        this.pointerOpen = this.series.open;
        clearTimeout(this.hoverTimer);
      });
      on(summary, 'pointercancel', () => { this.pointerOpen = undefined; });
      on(summary, 'click', event => {
        clearTimeout(this.hoverTimer);
        event.preventDefault();
        this.series.open = !(event.detail > 0 && this.pointerOpen !== undefined ? this.pointerOpen : this.series.open);
        this.pointerOpen = undefined;
      });
      on(this.series, 'toggle', () => { if (this.series.open) showPreview('0'); });
      on(this.series, 'pointerover', event => {
        const link = event.target.closest('[data-series-index]');
        if (link && !mobile.matches) showPreview(link.dataset.seriesIndex);
      });
      on(this.series, 'focusin', event => {
        clearTimeout(this.hoverTimer);
        const link = event.target.closest('[data-series-index]');
        if (link) showPreview(link.dataset.seriesIndex);
      });
      on(this.series, 'focusout', event => { if (!this.series.contains(event.relatedTarget)) closeSeries(); });
      on(this.series, 'keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); closeSeries(); summary.focus(); }
      });
      on(document, 'click', event => { if (!this.series?.contains(event.target)) closeSeries(); });
      on(mobile, 'change', () => { closeSeries(); if (this.drawer.open) this.drawer.close(); });
    }
    disconnectedCallback() {
      clearTimeout(this.hoverTimer);
      if (this.drawer?.open) this.drawer.close();
      this.events?.abort();
    }
  });
}
